import { render } from "./DemoDropdown.vue?vue&type=template&id=3497106c&scoped=true"
import script from "./DemoDropdown.vue?vue&type=script&lang=js"
export * from "./DemoDropdown.vue?vue&type=script&lang=js"

import "./DemoDropdown.vue?vue&type=style&index=0&id=3497106c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3497106c"]])

export default __exports__